export interface ReviewDisclosureInput {
  editorialReview?: 'human-reviewed' | 'review-not-recorded'
  humanReview?: { reviewerName?: string; reviewerRole?: string; reviewedAt?: string }
}

/** A legacy status flag is a declaration, not a named and dated review record. */
export function reviewDisclosure(value: ReviewDisclosureInput): {
  status: 'documented' | 'declared' | 'not-recorded'
  label: string
  sentence: string
} {
  const reviewer = typeof value.humanReview?.reviewerName === 'string' ? value.humanReview.reviewerName.trim() : ''
  const reviewedAt = value.humanReview?.reviewedAt
  if (value.editorialReview === 'human-reviewed' && reviewer && typeof reviewedAt === 'string' && Number.isFinite(Date.parse(reviewedAt))) {
    const date = new Date(reviewedAt).toISOString().slice(0, 10)
    return { status: 'documented', label: 'Human review documented', sentence: `Human review by ${reviewer} is recorded on ${date}.` }
  }
  if (value.editorialReview === 'human-reviewed') {
    return { status: 'declared', label: 'Review declared; details unavailable', sentence: 'The publication record declares human review, but a named and dated review record is not available.' }
  }
  return { status: 'not-recorded', label: 'No human review recorded', sentence: 'No human review is recorded. Verify consequential claims against the cited sources.' }
}
